import { Action } from '@ngrx/store';
import { PyramidalShareholderSearchFilter } from '../../models/pyramidalShareholderSearchFilter';

export enum EPyramidalShareholderListActions {
  SetSearchFilter = '[Pyramidal Shareholder List] SET SEARCH FILTER',
  SetPagination = '[Pyramidal Shareholder List] SET PAGINATION',
  SetSort = '[Pyramidal Shareholder List] SET SORT',
  ClearFilters = '[Pyramidal Shareholder List] CLEAR FILTERS'
}

export class SetSearchFilter implements Action {
  public readonly type = EPyramidalShareholderListActions.SetSearchFilter;
  constructor(public payload: Partial<PyramidalShareholderSearchFilter>) {}
}

export class SetPagination implements Action {
  public readonly type = EPyramidalShareholderListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetSort implements Action {
  public readonly type = EPyramidalShareholderListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearFilters implements Action {
  public readonly type = EPyramidalShareholderListActions.ClearFilters;
}

export type PyramidalShareholderListActions =
  | SetSearchFilter
  | SetPagination
  | SetSort
  | ClearFilters;
